import React, { useState, useEffect } from 'react';
import { FileText } from 'lucide-react';
import { publicationTermsService } from '../services/api';

function PublicationTerms() {
  const [publicationTerms, setPublicationTerms] = useState({
    contentRequirements: '',
    copyright: '',
    fees: '',
    republicationPolicy: '',
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPublicationTerms = async () => {
      try {
        const response = await publicationTermsService.get();
        if (response.data) {
          setPublicationTerms({
            contentRequirements: response.data.contentRequirements || '',
            copyright: response.data.copyright || '',
            fees: response.data.fees || '',
            republicationPolicy: response.data.republicationPolicy || '',
          });
        }
      } catch (error) {
        console.error('Error fetching publication terms:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPublicationTerms();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">شرایط انتشار</h1>
          <p className="text-xl text-blue-100">شرایط و الزامات برای انتشار مقالات</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="space-y-8">
          {publicationTerms.contentRequirements && (
            <section className="bg-white rounded-xl shadow-md p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <FileText className="text-blue-700" size={24} />
                الزامات محتوایی
              </h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                {publicationTerms.contentRequirements}
              </div>
            </section>
          )}

          {publicationTerms.copyright && (
            <section className="bg-white rounded-xl shadow-md p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">حقوق نشر و مالکیت</h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                {publicationTerms.copyright}
              </div>
            </section>
          )}

          {publicationTerms.fees && (
            <section className="bg-white rounded-xl shadow-md p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">هزینه‌های انتشار</h2>
              <div className="bg-blue-50 rounded-lg p-6 border-r-4 border-blue-700">
                <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                  {publicationTerms.fees}
                </div>
              </div>
            </section>
          )}

          {publicationTerms.republicationPolicy && (
            <section className="bg-white rounded-xl shadow-md p-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">سیاست بازنشر</h2>
              <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
                {publicationTerms.republicationPolicy}
              </div>
            </section>
          )}

          {!publicationTerms.contentRequirements && !publicationTerms.copyright && !publicationTerms.fees && !publicationTerms.republicationPolicy && (
            <div className="bg-white rounded-xl shadow-md p-8 text-center text-gray-500">
              <p>اطلاعاتی برای نمایش وجود ندارد</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PublicationTerms;
